import ApiService from "../api";

export default class RateioHistoricoService extends ApiService {
    constructor() {
        super('/api/solicitacoes/rateio-historico')
    }
    listarPorFornecedor(fornecedorId) { return this.get(`/fornecedor/${fornecedorId}`) }
}
